import { useQuery } from '@tanstack/react-query'

import { DocumentsTable } from '@/components/DocumentsTable'
import { Layout } from '@/components/Layout'
import { getDocuments } from '@/services/documents.service'
import { getEntities } from '@/services/entities.service'
import { DOCUMENT_TYPE_OPTIONS } from '@/utils/constants'

export default function Documents() {
  // GET entities
  const { data: entities } = useQuery({
    queryKey: ['admin', 'entities'],
    queryFn: () => getEntities('', { pageIndex: 0, pageSize: 99999 }),
  })

  const filters = [
    { type: 'input', label: 'Search', id: 'search' },
    {
      type: 'select',
      label: 'Type',
      id: 'type',
      options: DOCUMENT_TYPE_OPTIONS,
    },
    {
      type: 'select',
      label: 'Account',
      id: 'entity',
      options: entities
        ? entities.results.map((entity) => ({
            label: entity.name,
            id: entity.id,
          }))
        : [],
    },
  ]
  return (
    <Layout breadcrumbs={['Documents']}>
      <Layout.Heading title="Documents" />
      <DocumentsTable
        getDocuments={getDocuments}
        filters={filters}
        showAccount
        showOwner
        showType={false}
      />
    </Layout>
  )
}
